import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Subscription } from 'rxjs';
import { MessageBoxComponent } from '../../../core/shared/message-box.component';
import { Router, ActivatedRoute } from '@angular/router';
//import { TranslateService } from 'ng2-translate';
import { StructureUserEventsService } from '../structure-user-events.service';
import { UsersRest } from '../structure-users.rest';
import { UserComponent } from '../user/user.component';
import { ResetPasswordButton, ReactivateUserButton, DeactivateUserButton } from '../structure-users.model';
import { LoginRest } from '../../../login/login.rest';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-structure-users',
  templateUrl: './structure-users.component.html',
  styleUrls: ['./structure-users.component.css']
})
export class StructureUsersComponent implements OnInit, AfterViewInit, HasPermissions {
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }
  private roleId: string;

  public addOrUpdateEnable = false;
  public showSuccessMessage: boolean;
  public viewEnable = true;

  private toggleEnable = true;

  private successMessage: string;
  private path: string;
  private basePath: string;
  private messageBoxSubscription: Subscription;
  private selectSubscription: Subscription;
  private isDeleted: boolean;
  private isEditable: boolean;
  private loggedUserRole;
  private isLoggedAsAdmin: boolean;
  private additionalGridRowButtons = [];
  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild(UserComponent) public userComponent: UserComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private eventService: StructureUserEventsService,
    private rest: UsersRest,
    private loginRest: LoginRest,
    private spinnerService: SpinnerService,
    private permissionService: PermissionsService
  ) {
    this.selectSubscription = eventService.selectUserRoleElement$.subscribe(id => this.onSelectRole(id));
  }

  ngOnInit() {
    this.setPermissions("User");
    this.spinnerService.show();
    this.basePath = 'api/users/grid/';
    // this.loginRest.getUserRole().subscribe(data => {
    //   this.loggedUserRole = data;
    //     this.addOrUpdateEnable = true;
    // });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  private headers = [
    { displayName: 'Imię', propertyName: 'firstName', propertyType: 'string' },
    { displayName: 'Nazwisko', propertyName: 'lastName', propertyType: 'string' },
    { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
    { displayName: 'Przełożony', propertyName: 'superior', propertyType: 'string' },
    { displayName: 'Aktywny', propertyName: 'isActive', propertyType: 'bool' }
  ];

  // private getActionButtons() {
  //   return [];
  //   //   this.additionalGridRowButtons = [];
  //   // if(this.isLoggedAsAdmin){
  //   //   this.additionalGridRowButtons.push(new ResetPasswordButton());
  //   //   this.additionalGridRowButtons.push(new ReactivateUserButton());
  //   //   this.additionalGridRowButtons.push(new DeactivateUserButton());
  //   // }    

  //   // return this.additionalGridRowButtons;
  // }

  // private onActivate(actionData: any) {
  //   if(actionData.actionName === 'onResetPassword')
  //     this.resetPassword(actionData.selectedRow);
  //   else if(actionData.actionName === 'onDeactivateUser')
  //     this.deactivateUser(actionData.selectedRow);
  //   else if(actionData.actionName === 'onReactivateUser')
  //     this.activateUser(actionData.selectedRow);
  // }

  private onRowEdit(row: any) {
    this.isEditable = true;
    this.userComponent.openForEdit(row);
  }

  private onRowDelete(row: any) { }

  private addUser() {
    this.userComponent.openForAdding();
  }

  public onSuccessOperation(isActivationMode) {
    this.grid.refreshData();

    if (this.isDeleted) {
      this.showMesage('USER_deleteUser');
    }
    else if (!isActivationMode && !this.isEditable) {
      this.showMesage('USER_addUser');
    }
    else {
      this.showMesage('USER_editUser');
    }

    this.isDeleted = false;
    this.isEditable = false;
  }

  private onSelectRole(id: any) {
    this.roleId = id;
    this.path = `${this.basePath}${this.roleId}`;
    this.grid.currentPage = 0;
    this.grid.refreshData();
  }

  showMesage(translateMessage: string) {
    this.translateService.get(translateMessage).subscribe(
      (value) => {
        this.successMessage = value;
        sweetAlert(this.successMessage);
        // this.showSuccessMessage = true;
        // setTimeout(() => this.showSuccessMessage = false, 3000);
      });
  }

}
